<script>
import { mapGetters } from 'vuex'
import ProfileNav from '@/components/molecules/ProfileNav'

export default {
    name: 'Page',
    components: { ProfileNav },
    computed: {
        ...mapGetters(['lgDevice']),
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.$cart.calculate()
        })
    },
}
</script>

<template lang="pug">
.profile-page.container-fluid.container-md.pt-page 
    .row
        .col-12.col-md-4.col-lg-3.col-xxl-2.offset-xxl-2(v-if="lgDevice")
            profile-nav
            router-link.mt-8.btn.btn-primary.btn-pill(v-if="!$user.onlyCloudCanteen" :to="{name:'restaurant-list'}") {{$t('profile.find_food')}}
        .col-12.col-md-8.col-lg-9.col-xxl-6
            transition(name="fade" mode="out-in")
                router-view
</template>
